import React from "react";
import { NavLink } from "react-router-dom";


const NavLinks = ({ content, icon, dropdown = false, dropdownItems = [], url = '/' }) => {
  return (
    <li className="p-4 cursor-pointer group relative">
      <div className="flex justify-between items-center">
        {dropdown ? 
          <button type="button" className={'flex items-center gap-2'}><span>{icon}</span><span>{content}</span></button> : 
          <NavLink to={url} className={'flex items-center gap-2'}>
            <span>{icon}</span>
            <span>{content}</span>
          </NavLink>}
        {dropdown && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="size-4 mr-2"
          >
            <path
              fillRule="evenodd"
              d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z"
              clipRule="evenodd"
            />
          </svg>
        )}
      </div>
      {dropdown && dropdownItems.length > 0 && (
        <ul className="absolute w-max right-0 top-10 mt-2 bg-white shadow-lg rounded-md opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity py-4 px-2">
          {dropdownItems.map(({href,label,icon}, index) => (
            <li key={index} className="p-2 text-dark">
              <NavLink to={href} className="flex items-center gap-2 hover:opacity-50 transition-all"><span>{icon}</span> {label}</NavLink>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default NavLinks;
